import {confirmAlert} from "react-confirm-alert";
import React, {Component} from "react";
import DeleteDialog from "../../../../components/DeleteDialog";
import {deleteJobJournal} from "../../../../api";
import Card from "antd/es/card";
import Spinner, {spinnerOff, spinnerOn} from "../../../../components/Spinner";

const bodyStyle = {
    margin: "1.5rem"
};
const textStyle = {
    width: "80%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    position: "relative",
    whiteSpace: "nowrap"
};

const DeleteJobJournalDialogBody = ({journal}) => (
    <div style={bodyStyle}>
        <div>Are you sure you want to delete this Job Journal?</div>
        <Spinner/>
        <Card className="job-journal-delete-dialog">
            <div style={textStyle}><b>Title:</b> {journal.title}</div>
        </Card>
    </div>
);

const ShowDeleteJobJournalDialog = (projectId, journal, handleRefreshCall) => {

    const options = {
        closeOnEscape: true,
        customUI: ({onClose}) => <DeleteDialog
            onClose={onClose}
            onAccept={async () => {
                spinnerOn();
                await deleteJobJournal(journal.id);
                handleRefreshCall();
                onClose();
                spinnerOff();
            }}
            body={<DeleteJobJournalDialogBody journal={journal}/>}
        />
    };

    confirmAlert(options);
};

export default ShowDeleteJobJournalDialog;